import { createServerFn } from "@tanstack/react-start";

import { instantEventSchema } from "@/lib/instant-telemetry-events";
import { recordInstantEvent } from "@/lib/instant-telemetry.server";

export { INSTANT_EVENTS, type InstantEvent } from "@/lib/instant-telemetry-events";

/**
 * Diagnostics for the instant address report funnel. Writes are intentionally
 * unauthenticated (signed-out visitors use the form too); the table is
 * admin-read-only.
 */
export const logInstantEvent = createServerFn({ method: "POST" })
  .validator((input) => instantEventSchema.parse(input))
  .handler(async ({ data }): Promise<{ ok: boolean }> => {
    const { guardPublicRequest } = await import("@/lib/public-rate-limit.server");
    const guard = await guardPublicRequest("telemetry");
    // Diagnostics are best-effort: drop the event instead of erroring.
    if (!guard.ok) return { ok: false };
    return recordInstantEvent(data);
  });
